import { createReactComponent } from '@tabler/icons-react';

export const IconCustomDatabaseRibbon = createReactComponent(
  'outline',
  'customDatabaseRibbon',
  'CustomDatabaseRibbon',
  [
    [
      'path',
      {
        key: 'customDatabaseRibbon-path',
        d: 'M4 6C4 7.657 7.582 9 12 9C16.418 9 20 7.657 20 6M4 6C4 4.343 7.582 3 12 3C16.418 3 20 4.343 20 6M4 6V12M20 6V10.5M4 12V18C4 19.53 7.0539 20.7923 11 20.9768M4 12C4 13.53 7.0539 14.7923 11 14.9768M16 15H21V22L18.5 20.5L16 22V15Z',
      },
    ],
  ]
);
